(function() { window.GUID_452cf387_6dc4_4c2a_8fa4_a3bb4b7c8dd9 = { getGuid: function() { return "452cf387-6dc4-4c2a-8fa4-a3bb4b7c8dd9"; } }; })();
var Newsfeed;
(function (Newsfeed) {
    class NewsfeedPosts {
        constructor() {
            this.Filter = Newsfeed.Filter.ToMe;
            this.postsPerQuery = 10;
            this.files = [];
            this.fileNames = [];
            this.url = {
                createPost: CSParameters.RUrl + "NewsFeed/CreatePost/" + CSParameters.SportEventId,
                editPost: CSParameters.RUrl + "NewsFeed/EditPost/" + CSParameters.SportEventId,
                savePost: CSParameters.RUrl + "NewsFeed/SavePost/" + CSParameters.SportEventId,
                getPosts: CSParameters.RUrl + "NewsFeed/GetPosts/" + CSParameters.SportEventId,
            };
            this.$pinnedPostsContainer = $('#newsfeed-pinned-posts');
            this.$regularPostsContainer = $('#newsfeed-regular-posts');
            $(document).ready(() => {
                this.bindClickEvents();
                this.initializeLazyLoader();
            });
        }
        bindClickEvents() {
            let me = this;
            let $newsfeedTabButtons = $(".newsfeed-tab-button");
            let $btnHomePage = $("#BtnHomePage");
            let $newsfeed = $('#newsfeed');
            $newsfeedTabButtons.on("click", function (e) {
                e.preventDefault();
                var $target = $(this);
                me.setFilter($target, $newsfeedTabButtons);
            });
            $newsfeed.on('click', '.edit-post', function () {
                me.editPost($(this));
            });
            $newsfeed.on("click", ".edit-publicity", function () {
                window.location.href = CSParameters.RUrl + "Publicities/Index/" + CSParameters.SportEventId;
            });
            $newsfeed.on('click', '.pin-post', function () {
                me.pinPost($(this), true);
            });
            $newsfeed.on('click', '.dismiss-post', function () {
                me.dismissPost($(this), true);
            });
            $newsfeed.on('click', '.unpin-post', function () {
                me.pinPost($(this), false);
            });
            $newsfeed.on('click', '.ChangeOrderBtnOk', function () {
                let newPos = parseInt($(this).parent().find('select').val());
                let currentBox = $(this).parents(".newsfeed-post");
                currentBox.addClass("CurrentBox");
                let context = currentBox.parent();
                if (newPos == 0) {
                    currentBox.prependTo(context);
                }
                else {
                    context.find('.newsfeed-post:not(.CurrentBox)').each(function (i) {
                        let preBox = $(this);
                        if (i == newPos - 1) {
                            currentBox.insertAfter(preBox);
                            currentBox.removeClass("CurrentBox");
                        }
                    });
                }
            });
            CompuSport.DOM.body.offon("click.newsfeed", function (e) {
                let $target = $(e.target);
                //=============> Dropdown menu
                if ($target.closest("dropdown-content").length > 0) {
                    return;
                }
                if ($target.hasClass("dropdown-trigger")) {
                    me.quickEditPost($target);
                }
                else if ($target.closest("dropdown").length <= 0) {
                    $('#newsfeed').find(".dropdown-content").removeClass("show");
                }
                //=============> Create post
                if ($target.is("#create-post-button")) {
                    me.editPost($target);
                }
                else if ($target.closest("#create-post-button").length > 0) {
                    me.editPost($target.closest("#create-post-button").first());
                }
                //=============> Save post
                if ($target.hasClass("save-post")) {
                    me.savePost();
                }
                //=============> Delete post
                if ($target.hasClass("delete-post")) {
                    let element = this;
                    CompuSport.Controls.Popup.ShowConfirmDialogV2("", JSRess.AreYouSure, function () {
                        me.deletePost($target);
                    });
                }
                //=============> Edit post
                if ($target.children("input").first().attr("id") == "PublicationIsScheduled") {
                    me.toggleFormOptions("PublicationIsScheduled", "schedule-publication-option");
                }
                else if ($target.children("input").first().attr("id") == "DisappearanceIsScheduled") {
                    me.toggleFormOptions("DisappearanceIsScheduled", "schedule-disappearance-option");
                }
                else if ($target.children("input").first().attr("id") == "IsPinned") {
                    me.toggleFormCheckbox("IsPinned");
                }
                else if ($target.children("input").first().attr("id") == "IsGlobal") {
                    me.toggleFormCheckbox("IsGlobal");
                    me.toggleFormOptions("IsGlobal", "global-post-options");
                }
                else if ($target.children("input").first().attr("id") == "PublishOnNewEvents") {
                    me.toggleFormCheckbox("PublishOnNewEvents");
                }
                else if ($target.children("input").first().attr("id") == "IsDismissible") {
                    me.toggleFormCheckbox("IsDismissible");
                }
                else if ($target.is("#add-file")) {
                    e.preventDefault();
                    $('.file-upload-input').trigger('click');
                }
                else if ($target.hasClass("delete-file-button")) {
                    $target.closest("li").remove();
                }
                else if ($target.hasClass("delete-image-button")) {
                    $target.closest("li").remove();
                }
                else if ($target.hasClass("image-preview")) {
                    window.open($target.attr("src"), "_blank");
                }
                //=============> Advertising
                if ($target.is("#advertising-button")) {
                    window.open(CSParameters.RUrl + "Manage/Publicities/Index/" + CSParameters.SportEventId, "_blank");
                }
                else if ($target.closest("#advertising-button").length > 0) {
                    window.open(CSParameters.RUrl + "Manage/Publicities/Index/" + CSParameters.SportEventId, "_blank");
                }
                if ($target.hasClass("img-thumbnail") && $target.hasClass("advertising") && $target.hasClass("display-full-image")) {
                    if ($target.attr("data-advertising-url") != "") {
                        window.open($target.attr("data-advertising-url"), "_blank");
                    }
                }
                //=============> PhotoSwipe
                if ($target.hasClass("pswp__share--download")) {
                    e.preventDefault();
                }
                else if ($target.hasClass("pswp__ads-image") || $target.hasClass("pswp__ads-button")) {
                    let href = $target.attr("href");
                    let target = $target.attr("target");
                    if (href == "#" && target == "_self") {
                        return;
                    }
                    else {
                        window.open(href, target);
                    }
                }
            });
        }
        initializeLazyLoader() {
            let params = {
                loadURL: this.url.getPosts,
                loadElementsClass: "newsfeed-post-regular",
                $loadElementsContainer: $("#newsfeed-posts"),
                $triggerElement: $(`<span></span>`),
                getQuantity: this.postsPerQuery,
                filter: this.Filter,
                $scrollingContainer: $("#MasterBody"),
                onElementsObtained: this.insertPosts
            };
            this.lazyLoader = new CS.LazyLoader(params);
            this.lazyLoader.Start();
        }
        changeTab($target, $tabs) {
            if ($tabs.length > 0) {
                $tabs.each(function (index, element) {
                    $(element).removeClass("active");
                });
            }
            $target.addClass("active");
        }
        bindTabs($tabs, me) {
            if ($tabs.length > 0) {
                $tabs.each(function (index, element) {
                    $(element).bind("click", function (e) {
                        me.setFilter($(element), $tabs);
                    });
                });
            }
        }
        setFilter($target, $tabs) {
            let me = this;
            let newFilterName = me.snakeCaseToPascalCase($target.data("posts-filter"));
            let newFilterValue = Newsfeed.Filter[newFilterName];
            if (newFilterValue == this.Filter) {
                return;
            }
            else {
                this.lazyLoader.Stop();
                this.changeTab($target, $tabs);
                this.unbindTabButtons($tabs);
                this.removeAllPostsFromDOM();
                this.Filter = newFilterValue;
                this.lazyLoader.Filter = this.Filter;
                this.lazyLoader.Start();
                me.bindTabs($tabs, me);
            }
        }
        editPost($target) {
            let me = this;
            let $postContainer = $target.parents(".post-container").first();
            let url;
            let data = { postId: parseInt($postContainer.attr("id")) };
            if ($target.is("#create-post-button")) {
                data.postId = 0;
            }
            //Un ID de 0 signifie qu'il s'agit d'un nouveau post
            if (data.postId == 0) {
                url = me.url.createPost;
            }
            else {
                url = me.url.editPost;
            }
            me.postEditPopup = new CompuSport.Controls.Popup();
            me.postEditPopup.GetAndShow({
                PopupId: 'NewsFeedPopup',
                Url: url,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET,
            });
            me.postEditPopup.OnShowed = function () {
                // TODO : Charger jodit seulement si l'usager a les droits d'édition du post
                me.setTextEditor();
                me.getUploadedFiles();
                $('.CSDropDownCheckboxes').CSDropDownCheckboxes();
                me.toggleFormOptions("PublicationIsScheduled", "schedule-publication-option");
                me.toggleFormOptions("DisappearanceIsScheduled", "schedule-disappearance-option");
                me.toggleFormCheckbox("IsPinned");
                if ($("#master-admin-is-activated").length > 0) {
                    me.toggleFormCheckbox("IsGlobal");
                    me.toggleFormOptions("IsGlobal", "global-post-options");
                    me.toggleFormCheckbox("IsDismissible");
                    me.toggleFormCheckbox("PublishOnNewEvents");
                }
            };
        }
        quickEditPost(element) {
            element.focus();
            let $dropdownContainer = element.parents(".dropdown").first();
            let $dropdownMenu = $dropdownContainer.find(".dropdown-content").first();
            $dropdownMenu.toggleClass("show");
        }
        savePost() {
            let me = this, form = $("form").first(), id = parseInt($('.cancel-edition').attr("data-boxId")), $currentPost = $('#' + id), editor = form.find(".editor"), message = $('<div />').text(editor.html()).html();
            //Nécessaire pour éviter des bugs lorsque la string du post est décodée
            if (message == "") {
                editor.append("<p><br></p>");
            }
            message = $('<div />').text(editor.html()).html();
            me.setFiles();
            let postData = {
                Id: id,
                Title: $('#Title').val(),
                PublicationIsScheduled: $('#PublicationIsScheduled').val() == "true" ? true : false,
                PublicationDateString: $('#PublicationDateString').val(),
                PublicationTimeString: $('#PublicationTimeString').val(),
                DisappearanceIsScheduled: $('#DisappearanceIsScheduled').val() == "true" ? true : false,
                DisappearanceDateString: $('#DisappearanceDateString').val(),
                DisappearanceTimeString: $('#DisappearanceTimeString').val(),
                IsPinned: $('#IsPinned').val() == "true" ? true : false,
                Message: message,
                FileIds: me.files,
                FileNames: me.fileNames,
                IsGlobal: false,
                IsDismissible: true,
                PublishOnNewEvents: false,
                UserRoleString: "-100",
                EventTypeString: "4"
            };
            if ($("#master-admin-is-activated").length > 0) {
                postData.IsGlobal = $("#IsGlobal").val() == "true" ? true : false;
                postData.IsDismissible = $("#IsDismissible").val() == "true" ? true : false;
                postData.PublishOnNewEvents = $("#PublishOnNewEvents").val() == "true" ? true : false;
                postData.UserRoleString = $("table#UserRoleString").find(".SelectedItem").first().find(".dispval").text();
                postData.EventTypeString = $("table#EventTypeString").find(".SelectedItem").first().find(".dispval").text();
            }
            CompuSport.Ajax.Post(me.url.savePost, postData, function (response) {
                let $response = $(response);
                if (response.error) {
                    me.warning(response.invalidModelMsg);
                    return;
                }
                if (id != 0) {
                    $currentPost.remove();
                }
                me.insertPost($response, postData.IsPinned);
                new Newsfeed.NewsfeedPost($response);
                $(".newsfeed-post").show();
                //Un post ne peut être sauvegardé qu'en mode édition. Il faut donc afficher le menu d'édition rapide.
                $response.find('.post-edit').show();
                me.postEditPopup.Close();
            });
        }
        insertPost($post, isPinned) {
            let $postsContainer = (isPinned) ? this.$pinnedPostsContainer : this.$regularPostsContainer, $posts = $postsContainer.find('.newsfeed-post').not(".newsfeed-post-advertising"), date = $post.data("date");
            if ($posts.length > 0) {
                let $lastPost = $posts.last();
                let lastPostDate = $lastPost.data("date");
                for (var i = 0; i < $posts.length; i++) {
                    let $comparedPost = $($posts[i]), comparedPostDate = $comparedPost.data("date");
                    if (date > comparedPostDate) {
                        $post.insertBefore($comparedPost);
                        return false;
                    }
                }
                if (lastPostDate >= date) {
                    $post.insertAfter($lastPost);
                }
            }
            else {
                $post.prependTo($postsContainer);
            }
        }
        insertPosts($response) {
            if ($response.length > 0) {
                let $containerPinnedPosts = $("#newsfeed-pinned-posts"), $containerRegularPosts = $("#newsfeed-regular-posts");
                for (var i = 0; i < $response.length; i++) {
                    let $element = $($response[i]);
                    if ($element.hasClass("newsfeed-post")) {
                        let $post = $element, $container = ($element.hasClass("pinned")) ? $containerPinnedPosts : $containerRegularPosts;
                        $container.append($post);
                        new Newsfeed.NewsfeedPost($post);
                    }
                }
            }
        }
        pinPost(element, pin) {
            let me = this;
            let $post = element.parents(".newsfeed-post").first();
            let data = { postId: parseInt($post.attr("id")), isPinned: pin };
            $post.remove();
            CompuSport.Ajax.Post(CSParameters.RUrl + "NewsFeed/PinPost/" + CSParameters.SportEventId, data, function (response) {
                let $response = $(response);
                me.insertPost($response, pin);
                $response.find('.post-edit').show();
            });
        }
        dismissPost(element, pin) {
            let me = this;
            let $post = element.parents(".newsfeed-post").first();
            let data = { postId: parseInt($post.attr("id")) };
            $post.remove();
            CompuSport.Ajax.Post(CSParameters.RUrl + "NewsFeed/DismissPost/" + CSParameters.SportEventId, data, function (response) {
                let $response = $(response);
            });
        }
        deletePost(element) {
            var divNewsFeed = element.parents(".newsfeed-post").first();
            let data = { postId: parseInt(divNewsFeed.attr("id")), };
            let me = this;
            CompuSport.Ajax.Post(CSParameters.RUrl + "NewsFeed/DeletePost/" + CSParameters.SportEventId, data, function (response) {
                if (response.success) {
                    divNewsFeed.remove();
                }
                else {
                    me.warning(response.erreur);
                }
            });
        }
        removeAllPostsFromDOM() {
            let $currentPosts = $(".newsfeed-post");
            if ($currentPosts.length > 0) {
                for (let i = 0; i < $currentPosts.length; i++) {
                    $($currentPosts[i]).remove();
                }
            }
        }
        unbindTabButtons($tabs) {
            if ($tabs.length > 0) {
                $tabs.each(function (index, element) {
                    $(element).off("click");
                });
            }
        }
        setTextEditor() {
            $('.jodit-container').remove();
            let editor = $('form .editor');
            if (editor.data('original') == null) {
                editor.data('original', editor.html());
            }
            let languageAbbreviation = $("input.get-language-abbreviation").attr("value");
            let jodit = new Jodit('form .editor', {
                minHeight: 300,
                colorPickerDefaultTab: 'color',
                toolbarSticky: false,
                language: languageAbbreviation,
                toolbarDisableStickyForMobile: false,
                showCharsCounter: false,
                showWordsCounter: false,
                showXPathInStatusbar: false,
                toolbarAdaptive: false,
                cleanWhitespace: true,
                defaultActionOnPaste: 'insert_as_text',
                askBeforePasteFromWord: false,
                askBeforePasteHTML: false,
                enter: "p",
                theme: "compusport-web",
                width: 800,
                spellCheck: false,
                link: {
                    processVideoLink: true,
                    processPastedLink: true,
                    noFollowCheckbox: false,
                    openInNewTabCheckbox: false
                },
                buttons: [
                    "bold",
                    "strikethrough",
                    "underline",
                    "italic",
                    "|",
                    "paragraph",
                    "|",
                    "ul",
                    "ol",
                    // "align",
                    "|",
                    "link",
                    "video",
                ],
                extraButtons: ["emojis"],
            });
        }
        toggleFormOptions(checkboxId, optionClass) {
            let $formOptions = $(`.${optionClass}`);
            let $checkBox = $(`#${checkboxId}`);
            if ($checkBox.is(":checked")) {
                $checkBox.attr("value", "true");
                $formOptions.show();
            }
            else {
                $checkBox.attr("value", "false");
                $formOptions.hide();
            }
        }
        toggleFormCheckbox(checkboxId) {
            let $checkBox = $(`#${checkboxId}`);
            if ($checkBox.is(":checked")) {
                $checkBox.attr("value", "true");
            }
            else {
                $checkBox.attr("value", "false");
            }
        }
        warning(message) {
            CompuSport.Controls.Popup.ShowWarningDialog(message);
        }
        insertImage(result) {
            let $imageList = $('.image-list'), $newImageSection;
            if (result.height > result.width) {
                $newImageSection = $(`<li><img src="${result.relativeFilePath}" class="image-preview" width="100%" data-id="${result.fileId}" data-FileName="${result.fileName}" /><button class="delete-image-button" data-id="${result.fileId}"> X </button></li>`);
            }
            else {
                $newImageSection = $(`<li><img src="${result.relativeFilePath}" class="image-preview" height="100%" data-id="${result.fileId}" data-FileName="${result.fileName}" /><button class="delete-image-button" data-id="${result.fileId}"> X </button></li>`);
            }
            $imageList.append($newImageSection);
        }
        setFiles() {
            let me = this;
            me.files = [];
            me.fileNames = [];
            let uploadedFiles = $('.user-file');
            if (uploadedFiles) {
                uploadedFiles.each(function (index, elem) {
                    me.files.push(elem.getAttribute('data-id'));
                    me.fileNames.push(elem.textContent);
                });
            }
            let Images = $('.image-preview');
            if (Images) {
                Images.each(function (index, elem) {
                    me.files.push(elem.getAttribute('data-id'));
                    me.fileNames.push(elem.getAttribute('data-FileName'));
                });
            }
        }
        getUploadedFiles() {
            let me = this;
            var $file = $('.file-upload-input');
            if ($file != null && $file.length > 0) {
                $file.fileupload({
                    type: 'post',
                    dropZone: null,
                    replaceFileInput: false,
                    done: function (e, data) {
                        if (data._response.result.success) {
                            if (data._response.result.isImage) {
                                me.insertImage(data._response.result);
                            }
                            else {
                                me.insertFile(data._response.result);
                            }
                        }
                        else {
                            me.warning(data._response.result.message);
                        }
                    }
                });
            }
        }
        insertFile(result) {
            let $newFile = $(`<li><a href="/newsfeed/DownloadFile?fileId=${result.fileId}" class="user-file" data-id="${result.fileId}">${result.fileName}</a><button class="delete-file-button"> x </button></li>`);
            let $files = $(".preview-files");
            if ($files.find("ul").length == 0) {
                $files.append($("<ul></ul>"));
            }
            let $list = $(".preview-files").find("ul");
            $list.append($newFile);
        }
        snakeCaseToPascalCase(stringToConvert) {
            var camelCaseString = stringToConvert.replace(/([-_][a-z])/g, (group) => group.toUpperCase()
                .replace('-', '')
                .replace('_', ''));
            var firstLetter = camelCaseString.charAt(0);
            var pascalCaseString = camelCaseString.replace(firstLetter, firstLetter.toUpperCase());
            return pascalCaseString;
        }
    }
    Newsfeed.NewsfeedPosts = NewsfeedPosts;
})(Newsfeed || (Newsfeed = {}));

//# sourceMappingURL=newsfeed-posts.js.map
